import AbkhaziaIcon from '@/assets/icons/flags/abkhazia.svg?react';
import AfghanistanIcon from '@/assets/icons/flags/afghanistan.svg?react';
import AlandIslandsIcon from '@/assets/icons/flags/aland.svg?react';
import AlbaniaIcon from '@/assets/icons/flags/albania.svg?react';
import AlgeriaIcon from '@/assets/icons/flags/algeria.svg?react';
import AmericanSamoaIcon from '@/assets/icons/flags/american-samoa.svg?react';
import AndorraIcon from '@/assets/icons/flags/andorra.svg?react';
import AngolaIcon from '@/assets/icons/flags/angola.svg?react';
import AnguillaIcon from '@/assets/icons/flags/anguilla.svg?react';
import AntiguaAndBarbudaIcon from '@/assets/icons/flags/antigua-and-barbuda.svg?react';
import ArgentinaIcon from '@/assets/icons/flags/argentina.svg?react';
import ArmeniaIcon from '@/assets/icons/flags/armenia.svg?react';
import ArubaIcon from '@/assets/icons/flags/aruba.svg?react';
import AustraliaIcon from '@/assets/icons/flags/australia.svg?react';
import AustriaIcon from '@/assets/icons/flags/austria.svg?react';
import AzerbaijanIcon from '@/assets/icons/flags/azerbaijan.svg?react';
import AzoresIslandsIcon from '@/assets/icons/flags/azores-islands.svg?react';
import BahamasIcon from '@/assets/icons/flags/bahamas.svg?react';
import BahrainIcon from '@/assets/icons/flags/bahrain.svg?react';
import BalearicIslandsIcon from '@/assets/icons/flags/balearic-islands.svg?react';
import BangladeshIcon from '@/assets/icons/flags/bangladesh.svg?react';
import BarbadosIcon from '@/assets/icons/flags/barbados.svg?react';
import BasqueCountryIcon from '@/assets/icons/flags/basque-country.svg?react';
import BelarusIcon from '@/assets/icons/flags/belarus.svg?react';
import BelgiumIcon from '@/assets/icons/flags/belgium.svg?react';
import BelizeIcon from '@/assets/icons/flags/belize.svg?react';
import BeninIcon from '@/assets/icons/flags/benin.svg?react';
import BermudaIcon from '@/assets/icons/flags/bermuda.svg?react';
import BhutanIcon from '@/assets/icons/flags/bhutan.svg?react';
import BoliviaIcon from '@/assets/icons/flags/bolivia.svg?react';
import BonaireIcon from '@/assets/icons/flags/bonaire.svg?react';
import BosniaAndHerzegovinaIcon from '@/assets/icons/flags/bosnia-and-herzegovina.svg?react';
import BotswanaIcon from '@/assets/icons/flags/botswana.svg?react';
import BouvetIslandIcon from '@/assets/icons/flags/bouvet-island.svg?react';
import BrazilIcon from '@/assets/icons/flags/brazil.svg?react';
import BritishColumbiaIcon from '@/assets/icons/flags/british-columbia.svg?react';
import BritishIndianOceanTerritoryIcon from '@/assets/icons/flags/british-indian-ocean-territory.svg?react';
import BritishVirginIslandsIcon from '@/assets/icons/flags/british-virgin-islands.svg?react';
import BruneiIcon from '@/assets/icons/flags/brunei.svg?react';
import BulgariaIcon from '@/assets/icons/flags/bulgaria.svg?react';
import BurkinaFasoIcon from '@/assets/icons/flags/burkina-faso.svg?react';
import BurundiIcon from '@/assets/icons/flags/burundi.svg?react';
import CambodiaIcon from '@/assets/icons/flags/cambodia.svg?react';
import CameroonIcon from '@/assets/icons/flags/cameroon.svg?react';
import CanadaIcon from '@/assets/icons/flags/canada.svg?react';
import CanaryIslandsIcon from '@/assets/icons/flags/canary-islands.svg?react';
import CapeVerdeIcon from '@/assets/icons/flags/cape-verde.svg?react';
import CaymanIslandsIcon from '@/assets/icons/flags/cayman-islands.svg?react';
import CentralAfricanRepublicIcon from '@/assets/icons/flags/central-african-republic.svg?react';
import CeutaIcon from '@/assets/icons/flags/ceuta.svg?react';
import ChadIcon from '@/assets/icons/flags/chad.svg?react';
import ChileIcon from '@/assets/icons/flags/chile.svg?react';
import ChinaIcon from '@/assets/icons/flags/china.svg?react';
import ChristmasIslandIcon from '@/assets/icons/flags/christmas-island.svg?react';
import CocosIslandsIcon from '@/assets/icons/flags/cocos-(keeling)-islands.svg?react';
import ColombiaIcon from '@/assets/icons/flags/colombia.svg?react';
import ComorosIcon from '@/assets/icons/flags/comoros.svg?react';
import CookIslandsIcon from '@/assets/icons/flags/cook-islands.svg?react';
import CorsicaIcon from '@/assets/icons/flags/corsica.svg?react';
import CostaRicaIcon from '@/assets/icons/flags/costa-rica.svg?react';
import CroatiaIcon from '@/assets/icons/flags/croatia.svg?react';
import CubaIcon from '@/assets/icons/flags/cuba.svg?react';
import CuracaoIcon from '@/assets/icons/flags/curacao.svg?react';
import CyprusIcon from '@/assets/icons/flags/cyprus.svg?react';
import CzechRepublicIcon from '@/assets/icons/flags/czech-republic.svg?react';
import DemocraticRepublicOfTheCongoIcon from '@/assets/icons/flags/democratic-republic-of-the-congo.svg?react';
import DenmarkIcon from '@/assets/icons/flags/denmark.svg?react';
import DjiboutiIcon from '@/assets/icons/flags/djibouti.svg?react';
import DominicaIcon from '@/assets/icons/flags/dominica.svg?react';
import DominicanRepublicIcon from '@/assets/icons/flags/dominican-republic.svg?react';
import EastTimorIcon from '@/assets/icons/flags/east-timor.svg?react';
import EcuadorIcon from '@/assets/icons/flags/ecuador.svg?react';
import EgyptIcon from '@/assets/icons/flags/egypt.svg?react';
import ElSalvadorIcon from '@/assets/icons/flags/el-salvador.svg?react';
import EnglandIcon from '@/assets/icons/flags/england.svg?react';
import EquatorialGuineaIcon from '@/assets/icons/flags/equatorial-guinea.svg?react';
import EritreaIcon from '@/assets/icons/flags/eritrea.svg?react';
import EstoniaIcon from '@/assets/icons/flags/estonia.svg?react';
import SwazilandIcon from '@/assets/icons/flags/eswatini.svg?react';
import EthiopiaIcon from '@/assets/icons/flags/ethiopia.svg?react';
import FalklandIslandsIcon from '@/assets/icons/flags/falkland-islands.svg?react';
import FaroeIslandsIcon from '@/assets/icons/flags/faroe-islands.svg?react';
import FijiIcon from '@/assets/icons/flags/fiji.svg?react';
import FinlandIcon from '@/assets/icons/flags/finland.svg?react';
import FranceIcon from '@/assets/icons/flags/france.svg?react';
import FrenchPolynesiaIcon from '@/assets/icons/flags/french-polynesia.svg?react';
import FrenchSouthernTerritoriesIcon from '@/assets/icons/flags/french-southern-territories.svg?react';
import GabonIcon from '@/assets/icons/flags/gabon.svg?react';
import GalapagosIslandsIcon from '@/assets/icons/flags/galapagos-islands.svg?react';
import GambiaIcon from '@/assets/icons/flags/gambia.svg?react';
import GeorgiaIcon from '@/assets/icons/flags/georgia.svg?react';
import GermanyIcon from '@/assets/icons/flags/germany.svg?react';
import GhanaIcon from '@/assets/icons/flags/ghana.svg?react';
import GibraltarIcon from '@/assets/icons/flags/gibraltar.svg?react';
import GreeceIcon from '@/assets/icons/flags/greece.svg?react';
import GreenlandIcon from '@/assets/icons/flags/greenland.svg?react';
import GrenadaIcon from '@/assets/icons/flags/grenada.svg?react';
import GuamIcon from '@/assets/icons/flags/guam.svg?react';
import GuatemalaIcon from '@/assets/icons/flags/guatemala.svg?react';
import GuernseyIcon from '@/assets/icons/flags/guernsey.svg?react';
import GuineaBissauIcon from '@/assets/icons/flags/guinea-bissau.svg?react';
import GuineaIcon from '@/assets/icons/flags/guinea.svg?react';
import GuyanaIcon from '@/assets/icons/flags/guyana.svg?react';
import HaitiIcon from '@/assets/icons/flags/haiti.svg?react';
import HawaiiIcon from '@/assets/icons/flags/hawaii.svg?react';
import HeardIslandAndMcdonaldIslandsIcon from '@/assets/icons/flags/heard-island-and-mcdonald-islands.svg?react';
import HondurasIcon from '@/assets/icons/flags/honduras.svg?react';
import HongKongIcon from '@/assets/icons/flags/hong-kong.svg?react';
import HungaryIcon from '@/assets/icons/flags/hungary.svg?react';
import IcelandIcon from '@/assets/icons/flags/iceland.svg?react';
import IndiaIcon from '@/assets/icons/flags/india.svg?react';
import IndonesiaIcon from '@/assets/icons/flags/indonesia.svg?react';
import IranIcon from '@/assets/icons/flags/iran.svg?react';
import IraqIcon from '@/assets/icons/flags/iraq.svg?react';
import IrelandIcon from '@/assets/icons/flags/ireland.svg?react';
import IsleOfManIcon from '@/assets/icons/flags/isle-of-man.svg?react';
import IsraelIcon from '@/assets/icons/flags/israel.svg?react';
import ItalyIcon from '@/assets/icons/flags/italy.svg?react';
import IvoryCoastIcon from '@/assets/icons/flags/ivory-coast.svg?react';
import JamaicaIcon from '@/assets/icons/flags/jamaica.svg?react';
import JapanIcon from '@/assets/icons/flags/japan.svg?react';
import JerseyIcon from '@/assets/icons/flags/jersey.svg?react';
import JordanIcon from '@/assets/icons/flags/jordan.svg?react';
import KazakhstanIcon from '@/assets/icons/flags/kazakhstan.svg?react';
import KenyaIcon from '@/assets/icons/flags/kenya.svg?react';
import KiribatiIcon from '@/assets/icons/flags/kiribati.svg?react';
import KosovoIcon from '@/assets/icons/flags/kosovo.svg?react';
import KuwaitIcon from '@/assets/icons/flags/kuwait.svg?react';
import KyrgyzstanIcon from '@/assets/icons/flags/kyrgyzstan.svg?react';
import LaosIcon from '@/assets/icons/flags/laos.svg?react';
import LatviaIcon from '@/assets/icons/flags/latvia.svg?react';
import LebanonIcon from '@/assets/icons/flags/lebanon.svg?react';
import LesothoIcon from '@/assets/icons/flags/lesotho.svg?react';
import LiberiaIcon from '@/assets/icons/flags/liberia.svg?react';
import LibyaIcon from '@/assets/icons/flags/libya.svg?react';
import LiechtensteinIcon from '@/assets/icons/flags/liechtenstein.svg?react';
import LithuaniaIcon from '@/assets/icons/flags/lithuania.svg?react';
import LuxembourgIcon from '@/assets/icons/flags/luxembourg.svg?react';
import MacaoIcon from '@/assets/icons/flags/macao.svg?react';
import MadagascarIcon from '@/assets/icons/flags/madagascar.svg?react';
import MadeiraIcon from '@/assets/icons/flags/madeira.svg?react';
import MalawiIcon from '@/assets/icons/flags/malawi.svg?react';
import MalaysiaIcon from '@/assets/icons/flags/malaysia.svg?react';
import MaldivesIcon from '@/assets/icons/flags/maldives.svg?react';
import MaliIcon from '@/assets/icons/flags/mali.svg?react';
import MaltaIcon from '@/assets/icons/flags/malta.svg?react';
import MarshallIslandsIcon from '@/assets/icons/flags/marshall-islands.svg?react';
import MartiniqueIcon from '@/assets/icons/flags/martinique.svg?react';
import MauritaniaIcon from '@/assets/icons/flags/mauritania.svg?react';
import MauritiusIcon from '@/assets/icons/flags/mauritius.svg?react';
import MelillaIcon from '@/assets/icons/flags/melilla.svg?react';
import MexicoIcon from '@/assets/icons/flags/mexico.svg?react';
import MicronesiaIcon from '@/assets/icons/flags/micronesia.svg?react';
import MoldovaIcon from '@/assets/icons/flags/moldova.svg?react';
import MonacoIcon from '@/assets/icons/flags/monaco.svg?react';
import MongoliaIcon from '@/assets/icons/flags/mongolia.svg?react';
import MontenegroIcon from '@/assets/icons/flags/montenegro.svg?react';
import MontserratIcon from '@/assets/icons/flags/montserrat.svg?react';
import MoroccoIcon from '@/assets/icons/flags/morocco.svg?react';
import MozambiqueIcon from '@/assets/icons/flags/mozambique.svg?react';
import MyanmarIcon from '@/assets/icons/flags/myanmar.svg?react';
import NamibiaIcon from '@/assets/icons/flags/namibia.svg?react';
import NauruIcon from '@/assets/icons/flags/nauru.svg?react';
import NepalIcon from '@/assets/icons/flags/nepal.svg?react';
import NetherlandsIcon from '@/assets/icons/flags/netherlands.svg?react';
import NewCaledoniaIcon from '@/assets/icons/flags/new-caledonia.svg?react';
import NewZealandIcon from '@/assets/icons/flags/new-zealand.svg?react';
import NicaraguaIcon from '@/assets/icons/flags/nicaragua.svg?react';
import NigerIcon from '@/assets/icons/flags/niger.svg?react';
import NigeriaIcon from '@/assets/icons/flags/nigeria.svg?react';
import NiueIcon from '@/assets/icons/flags/niue.svg?react';
import NorfolkIslandIcon from '@/assets/icons/flags/norfolk-island.svg?react';
import NorthKoreaIcon from '@/assets/icons/flags/north-korea.svg?react';
import RepublicOfMacedoniaIcon from '@/assets/icons/flags/north-macedonia.svg?react';
import NorthernCyprusIcon from '@/assets/icons/flags/northern-cyprus.svg?react';
import NorthernMarianaIslandsIcon from '@/assets/icons/flags/northern-mariana-islands.svg?react';
import NorwayIcon from '@/assets/icons/flags/norway.svg?react';
import OmanIcon from '@/assets/icons/flags/oman.svg?react';
import OrkneyIslandsIcon from '@/assets/icons/flags/orkney-islands.svg?react';
import OssetiaIcon from '@/assets/icons/flags/ossetia.svg?react';
import PakistanIcon from '@/assets/icons/flags/pakistan.svg?react';
import PalauIcon from '@/assets/icons/flags/palau.svg?react';
import PalestineIcon from '@/assets/icons/flags/palestine.svg?react';
import PanamaIcon from '@/assets/icons/flags/panama.svg?react';
import PapuaNewGuineaIcon from '@/assets/icons/flags/papua-new-guinea.svg?react';
import ParaguayIcon from '@/assets/icons/flags/paraguay.svg?react';
import PeruIcon from '@/assets/icons/flags/peru.svg?react';
import PhilippinesIcon from '@/assets/icons/flags/philippines.svg?react';
import PitcairnIslandsIcon from '@/assets/icons/flags/pitcairn-islands.svg?react';
import PolandIcon from '@/assets/icons/flags/poland.svg?react';
import PortugalIcon from '@/assets/icons/flags/portugal.svg?react';
import PuertoRicoIcon from '@/assets/icons/flags/puerto-rico.svg?react';
import QatarIcon from '@/assets/icons/flags/qatar.svg?react';
import RapaNuiIcon from '@/assets/icons/flags/rapa-nui.svg?react';
import RepublicOfTheCongoIcon from '@/assets/icons/flags/republic-of-the-congo.svg?react';
import RomaniaIcon from '@/assets/icons/flags/romania.svg?react';
import RussiaIcon from '@/assets/icons/flags/russia.svg?react';
import RwandaIcon from '@/assets/icons/flags/rwanda.svg?react';
import SabaIslandIcon from '@/assets/icons/flags/saba-island.svg?react';
import SahrawiArabDemocraticRepublicIcon from '@/assets/icons/flags/sahrawi-arab-democratic-republic.svg?react';
import StBartsIcon from '@/assets/icons/flags/saint-barthelemy.svg?react';
import StHelenaIcon from '@/assets/icons/flags/saint-helena.svg?react';
import StKittsNevisIcon from '@/assets/icons/flags/saint-kitts-and-nevis.svg?react';
import StLuciaIcon from '@/assets/icons/flags/saint-lucia.svg?react';
import StMartinIcon from '@/assets/icons/flags/saint-martin.svg?react';
import StVincentAndTheGrenadinesIcon from '@/assets/icons/flags/saint-vincent-and-the-grenadines.svg?react';
import SamoaIcon from '@/assets/icons/flags/samoa.svg?react';
import SanMarinoIcon from '@/assets/icons/flags/san-marino.svg?react';
import SaoTomeAndPrincipeIcon from '@/assets/icons/flags/sao-tome-and-principe.svg?react';
import SardiniaIcon from '@/assets/icons/flags/sardinia.svg?react';
import SaudiArabiaIcon from '@/assets/icons/flags/saudi-arabia.svg?react';
import ScotlandIcon from '@/assets/icons/flags/scotland.svg?react';
import SenegalIcon from '@/assets/icons/flags/senegal.svg?react';
import SerbiaIcon from '@/assets/icons/flags/serbia.svg?react';
import SeychellesIcon from '@/assets/icons/flags/seychelles.svg?react';
import SierraLeoneIcon from '@/assets/icons/flags/sierra-leone.svg?react';
import SingaporeIcon from '@/assets/icons/flags/singapore.svg?react';
import SintEustatiusIcon from '@/assets/icons/flags/sint-eustatius.svg?react';
import SintMaartenIcon from '@/assets/icons/flags/sint-maarten.svg?react';
import SlovakiaIcon from '@/assets/icons/flags/slovakia.svg?react';
import SloveniaIcon from '@/assets/icons/flags/slovenia.svg?react';
import SolomonIslandsIcon from '@/assets/icons/flags/solomon-islands.svg?react';
import SomaliaIcon from '@/assets/icons/flags/somalia.svg?react';
import SomalilandIcon from '@/assets/icons/flags/somaliland.svg?react';
import SouthAfricaIcon from '@/assets/icons/flags/south-africa.svg?react';
import SouthGeorgiaAndTheSouthSandwichIslandsIcon from '@/assets/icons/flags/south-georgia-and-the-south-sandwich-islands.svg?react';
import SouthKoreaIcon from '@/assets/icons/flags/south-korea.svg?react';
import SouthSudanIcon from '@/assets/icons/flags/south-sudan.svg?react';
import SpainIcon from '@/assets/icons/flags/spain.svg?react';
import SriLankaIcon from '@/assets/icons/flags/sri-lanka.svg?react';
import SudanIcon from '@/assets/icons/flags/sudan.svg?react';
import SurinameIcon from '@/assets/icons/flags/suriname.svg?react';
import SwedenIcon from '@/assets/icons/flags/sweden.svg?react';
import SwitzerlandIcon from '@/assets/icons/flags/switzerland.svg?react';
import SyriaIcon from '@/assets/icons/flags/syria.svg?react';
import TaiwanIcon from '@/assets/icons/flags/taiwan.svg?react';
import TajikistanIcon from '@/assets/icons/flags/tajikistan.svg?react';
import TanzaniaIcon from '@/assets/icons/flags/tanzania.svg?react';
import ThailandIcon from '@/assets/icons/flags/thailand.svg?react';
import TibetIcon from '@/assets/icons/flags/tibet.svg?react';
import TogoIcon from '@/assets/icons/flags/togo.svg?react';
import TokelauIcon from '@/assets/icons/flags/tokelau.svg?react';
import TongaIcon from '@/assets/icons/flags/tonga.svg?react';
import TransnistriaIcon from '@/assets/icons/flags/transnistria.svg?react';
import TrinidadAndTobagoIcon from '@/assets/icons/flags/trinidad-and-tobago.svg?react';
import TunisiaIcon from '@/assets/icons/flags/tunisia.svg?react';
import TurkeyIcon from '@/assets/icons/flags/turkey.svg?react';
import TurkmenistanIcon from '@/assets/icons/flags/turkmenistan.svg?react';
import TurksAndCaicosIcon from '@/assets/icons/flags/turks-and-caicos-islands.svg?react';
import TuvaluIcon from '@/assets/icons/flags/tuvalu.svg?react';
import VirginIslandsIcon from '@/assets/icons/flags/u.s.-virgin-islands.svg?react';
import UgandaIcon from '@/assets/icons/flags/uganda.svg?react';
import UkraineIcon from '@/assets/icons/flags/ukraine.svg?react';
import UnitedArabEmiratesIcon from '@/assets/icons/flags/united-arab-emirates.svg?react';
import UnitedKingdomIcon from '@/assets/icons/flags/united-kingdom.svg?react';
import UnitedStatesIcon from '@/assets/icons/flags/united-states.svg?react';
import UruguayIcon from '@/assets/icons/flags/uruguay.svg?react';
import UzbekistanIcon from '@/assets/icons/flags/uzbekistan.svg?react';
import VanuatuIcon from '@/assets/icons/flags/vanuatu.svg?react';
import VaticanCityIcon from '@/assets/icons/flags/vatican-city.svg?react';
import VenezuelaIcon from '@/assets/icons/flags/venezuela.svg?react';
import VietnamIcon from '@/assets/icons/flags/vietnam.svg?react';
import WalesIcon from '@/assets/icons/flags/wales.svg?react';
import WesternSaharaIcon from '@/assets/icons/flags/western-sahara.svg?react';
import YemenIcon from '@/assets/icons/flags/yemen.svg?react';
import ZambiaIcon from '@/assets/icons/flags/zambia.svg?react';
import ZimbabweIcon from '@/assets/icons/flags/zimbabwe.svg?react';

export const COUNTRY_FLAG_ICON_COMPONENTS = {
  'flag-abkhazia': AbkhaziaIcon,
  'flag-afghanistan': AfghanistanIcon,
  'flag-aland': AlandIslandsIcon,
  'flag-albania': AlbaniaIcon,
  'flag-algeria': AlgeriaIcon,
  'flag-american-samoa': AmericanSamoaIcon,
  'flag-andorra': AndorraIcon,
  'flag-angola': AngolaIcon,
  'flag-anguilla': AnguillaIcon,
  'flag-antigua-and-barbuda': AntiguaAndBarbudaIcon,
  'flag-argentina': ArgentinaIcon,
  'flag-armenia': ArmeniaIcon,
  'flag-aruba': ArubaIcon,
  'flag-australia': AustraliaIcon,
  'flag-austria': AustriaIcon,
  'flag-azerbaijan': AzerbaijanIcon,
  'flag-azores-islands': AzoresIslandsIcon,
  'flag-bahamas': BahamasIcon,
  'flag-bahrain': BahrainIcon,
  'flag-balearic-islands': BalearicIslandsIcon,
  'flag-bangladesh': BangladeshIcon,
  'flag-barbados': BarbadosIcon,
  'flag-basque-country': BasqueCountryIcon,
  'flag-belarus': BelarusIcon,
  'flag-belgium': BelgiumIcon,
  'flag-belize': BelizeIcon,
  'flag-benin': BeninIcon,
  'flag-bermuda': BermudaIcon,
  'flag-bhutan': BhutanIcon,
  'flag-bolivia': BoliviaIcon,
  'flag-bonaire': BonaireIcon,
  'flag-bosnia-and-herzegovina': BosniaAndHerzegovinaIcon,
  'flag-botswana': BotswanaIcon,
  'flag-bouvet-island': BouvetIslandIcon,
  'flag-brazil': BrazilIcon,
  'flag-british-columbia': BritishColumbiaIcon,
  'flag-british-indian-ocean-territory': BritishIndianOceanTerritoryIcon,
  'flag-british-virgin-islands': BritishVirginIslandsIcon,
  'flag-brunei': BruneiIcon,
  'flag-bulgaria': BulgariaIcon,
  'flag-burkina-faso': BurkinaFasoIcon,
  'flag-burundi': BurundiIcon,
  'flag-cambodia': CambodiaIcon,
  'flag-cameroon': CameroonIcon,
  'flag-canada': CanadaIcon,
  'flag-canary-islands': CanaryIslandsIcon,
  'flag-cape-verde': CapeVerdeIcon,
  'flag-cayman-islands': CaymanIslandsIcon,
  'flag-central-african-republic': CentralAfricanRepublicIcon,
  'flag-ceuta': CeutaIcon,
  'flag-chad': ChadIcon,
  'flag-chile': ChileIcon,
  'flag-china': ChinaIcon,
  'flag-christmas-island': ChristmasIslandIcon,
  'flag-cocos-(keeling)-islands': CocosIslandsIcon,
  'flag-colombia': ColombiaIcon,
  'flag-comoros': ComorosIcon,
  'flag-cook-islands': CookIslandsIcon,
  'flag-corsica': CorsicaIcon,
  'flag-costa-rica': CostaRicaIcon,
  'flag-croatia': CroatiaIcon,
  'flag-cuba': CubaIcon,
  'flag-curacao': CuracaoIcon,
  'flag-cyprus': CyprusIcon,
  'flag-czech-republic': CzechRepublicIcon,
  'flag-democratic-republic-of-the-congo': DemocraticRepublicOfTheCongoIcon,
  'flag-denmark': DenmarkIcon,
  'flag-djibouti': DjiboutiIcon,
  'flag-dominica': DominicaIcon,
  'flag-dominican-republic': DominicanRepublicIcon,
  'flag-east-timor': EastTimorIcon,
  'flag-ecuador': EcuadorIcon,
  'flag-egypt': EgyptIcon,
  'flag-el-salvador': ElSalvadorIcon,
  'flag-england': EnglandIcon,
  'flag-equatorial-guinea': EquatorialGuineaIcon,
  'flag-eritrea': EritreaIcon,
  'flag-estonia': EstoniaIcon,
  'flag-ethiopia': EthiopiaIcon,
  'flag-falkland-islands': FalklandIslandsIcon,
  'flag-faroe-islands': FaroeIslandsIcon,
  'flag-fiji': FijiIcon,
  'flag-finland': FinlandIcon,
  'flag-france': FranceIcon,
  'flag-french-guiana': FranceIcon,
  'flag-mayotte': FranceIcon,
  'flag-guadeloupe': FranceIcon,
  'flag-reunion': FranceIcon,
  'flag-saint-pierre-and-miquelon': FranceIcon,
  'flag-wallis-and-futuna': FranceIcon,
  'flag-french-polynesia': FrenchPolynesiaIcon,
  'flag-french-southern-territories': FrenchSouthernTerritoriesIcon,
  'flag-gabon': GabonIcon,
  'flag-galapagos-islands': GalapagosIslandsIcon,
  'flag-gambia': GambiaIcon,
  'flag-georgia': GeorgiaIcon,
  'flag-germany': GermanyIcon,
  'flag-ghana': GhanaIcon,
  'flag-gibraltar': GibraltarIcon,
  'flag-greece': GreeceIcon,
  'flag-greenland': GreenlandIcon,
  'flag-grenada': GrenadaIcon,
  'flag-guam': GuamIcon,
  'flag-guatemala': GuatemalaIcon,
  'flag-guernsey': GuernseyIcon,
  'flag-guinea-bissau': GuineaBissauIcon,
  'flag-guinea': GuineaIcon,
  'flag-guyana': GuyanaIcon,
  'flag-haiti': HaitiIcon,
  'flag-hawaii': HawaiiIcon,
  'flag-honduras': HondurasIcon,
  'flag-heard-island-and-mcdonald-islands': HeardIslandAndMcdonaldIslandsIcon,
  'flag-hong-kong': HongKongIcon,
  'flag-hungary': HungaryIcon,
  'flag-iceland': IcelandIcon,
  'flag-india': IndiaIcon,
  'flag-indonesia': IndonesiaIcon,
  'flag-iran': IranIcon,
  'flag-iraq': IraqIcon,
  'flag-ireland': IrelandIcon,
  'flag-isle-of-man': IsleOfManIcon,
  'flag-israel': IsraelIcon,
  'flag-italy': ItalyIcon,
  'flag-ivory-coast': IvoryCoastIcon,
  'flag-jamaica': JamaicaIcon,
  'flag-japan': JapanIcon,
  'flag-jersey': JerseyIcon,
  'flag-jordan': JordanIcon,
  'flag-kazakhstan': KazakhstanIcon,
  'flag-kenya': KenyaIcon,
  'flag-kiribati': KiribatiIcon,
  'flag-kosovo': KosovoIcon,
  'flag-kuwait': KuwaitIcon,
  'flag-kyrgyzstan': KyrgyzstanIcon,
  'flag-laos': LaosIcon,
  'flag-latvia': LatviaIcon,
  'flag-lebanon': LebanonIcon,
  'flag-lesotho': LesothoIcon,
  'flag-liberia': LiberiaIcon,
  'flag-libya': LibyaIcon,
  'flag-liechtenstein': LiechtensteinIcon,
  'flag-lithuania': LithuaniaIcon,
  'flag-luxembourg': LuxembourgIcon,
  'flag-macao': MacaoIcon,
  'flag-madagascar': MadagascarIcon,
  'flag-madeira': MadeiraIcon,
  'flag-malawi': MalawiIcon,
  'flag-malaysia': MalaysiaIcon,
  'flag-maldives': MaldivesIcon,
  'flag-mali': MaliIcon,
  'flag-malta': MaltaIcon,
  'flag-marshall-islands': MarshallIslandsIcon,
  'flag-martinique': MartiniqueIcon,
  'flag-mauritania': MauritaniaIcon,
  'flag-mauritius': MauritiusIcon,
  'flag-melilla': MelillaIcon,
  'flag-mexico': MexicoIcon,
  'flag-micronesia': MicronesiaIcon,
  'flag-moldova': MoldovaIcon,
  'flag-monaco': MonacoIcon,
  'flag-mongolia': MongoliaIcon,
  'flag-montenegro': MontenegroIcon,
  'flag-montserrat': MontserratIcon,
  'flag-morocco': MoroccoIcon,
  'flag-mozambique': MozambiqueIcon,
  'flag-myanmar-(burma)': MyanmarIcon,
  'flag-namibia': NamibiaIcon,
  'flag-nauru': NauruIcon,
  'flag-nepal': NepalIcon,
  'flag-netherlands': NetherlandsIcon,
  'flag-new-caledonia': NewCaledoniaIcon,
  'flag-new-zealand': NewZealandIcon,
  'flag-nicaragua': NicaraguaIcon,
  'flag-niger': NigerIcon,
  'flag-nigeria': NigeriaIcon,
  'flag-niue': NiueIcon,
  'flag-norfolk-island': NorfolkIslandIcon,
  'flag-north-korea': NorthKoreaIcon,
  'flag-northern-cyprus': NorthernCyprusIcon,
  'flag-north-macedonia': RepublicOfMacedoniaIcon,
  'flag-northern-mariana-islands': NorthernMarianaIslandsIcon,
  'flag-norway': NorwayIcon,
  'flag-svalbard-and-jan-mayen': NorwayIcon,
  'flag-oman': OmanIcon,
  'flag-orkney-islands': OrkneyIslandsIcon,
  'flag-ossetia': OssetiaIcon,
  'flag-pakistan': PakistanIcon,
  'flag-palau': PalauIcon,
  'flag-palestine': PalestineIcon,
  'flag-panama': PanamaIcon,
  'flag-papua-new-guinea': PapuaNewGuineaIcon,
  'flag-paraguay': ParaguayIcon,
  'flag-peru': PeruIcon,
  'flag-philippines': PhilippinesIcon,
  'flag-pitcairn-islands': PitcairnIslandsIcon,
  'flag-poland': PolandIcon,
  'flag-portugal': PortugalIcon,
  'flag-puerto-rico': PuertoRicoIcon,
  'flag-qatar': QatarIcon,
  'flag-rapa-nui': RapaNuiIcon,
  'flag-republic-of-the-congo': RepublicOfTheCongoIcon,
  'flag-romania': RomaniaIcon,
  'flag-russia': RussiaIcon,
  'flag-rwanda': RwandaIcon,
  'flag-saba-island': SabaIslandIcon,
  'flag-sahrawi-arab-democratic-republic': SahrawiArabDemocraticRepublicIcon,
  'flag-samoa': SamoaIcon,
  'flag-san-marino': SanMarinoIcon,
  'flag-sao-tome-and-principe': SaoTomeAndPrincipeIcon,
  'flag-sardinia': SardiniaIcon,
  'flag-saudi-arabia': SaudiArabiaIcon,
  'flag-scotland': ScotlandIcon,
  'flag-senegal': SenegalIcon,
  'flag-serbia': SerbiaIcon,
  'flag-seychelles': SeychellesIcon,
  'flag-sierra-leone': SierraLeoneIcon,
  'flag-singapore': SingaporeIcon,
  'flag-sint-eustatius': SintEustatiusIcon,
  'flag-sint-maarten': SintMaartenIcon,
  'flag-slovakia': SlovakiaIcon,
  'flag-slovenia': SloveniaIcon,
  'flag-solomon-islands': SolomonIslandsIcon,
  'flag-somalia': SomaliaIcon,
  'flag-somaliland': SomalilandIcon,
  'flag-south-africa': SouthAfricaIcon,
  'flag-south-georgia-and-the-south-sandwich-islands':
    SouthGeorgiaAndTheSouthSandwichIslandsIcon,
  'flag-south-korea': SouthKoreaIcon,
  'flag-south-sudan': SouthSudanIcon,
  'flag-spain': SpainIcon,
  'flag-sri-lanka': SriLankaIcon,
  'flag-saint-barthelemy': StBartsIcon,
  'flag-saint-helena': StHelenaIcon,
  'flag-saint-kitts-and-nevis': StKittsNevisIcon,
  'flag-saint-lucia': StLuciaIcon,
  'flag-saint-martin': StMartinIcon,
  'flag-saint-vincent-and-the-grenadines': StVincentAndTheGrenadinesIcon,
  'flag-sudan': SudanIcon,
  'flag-suriname': SurinameIcon,
  'flag-eswatini': SwazilandIcon,
  'flag-sweden': SwedenIcon,
  'flag-switzerland': SwitzerlandIcon,
  'flag-syria': SyriaIcon,
  'flag-taiwan': TaiwanIcon,
  'flag-tajikistan': TajikistanIcon,
  'flag-tanzania': TanzaniaIcon,
  'flag-thailand': ThailandIcon,
  'flag-tibet': TibetIcon,
  'flag-togo': TogoIcon,
  'flag-tokelau': TokelauIcon,
  'flag-tonga': TongaIcon,
  'flag-transnistria': TransnistriaIcon,
  'flag-trinidad-and-tobago': TrinidadAndTobagoIcon,
  'flag-tunisia': TunisiaIcon,
  'flag-turkey': TurkeyIcon,
  'flag-turkmenistan': TurkmenistanIcon,
  'flag-turks-and-caicos-islands': TurksAndCaicosIcon,
  'flag-tuvalu': TuvaluIcon,
  'flag-uganda': UgandaIcon,
  'flag-ukraine': UkraineIcon,
  'flag-united-arab-emirates': UnitedArabEmiratesIcon,
  'flag-united-kingdom': UnitedKingdomIcon,
  'flag-united-states': UnitedStatesIcon,
  'flag-u.s.-minor-outlying-islands': UnitedStatesIcon,
  'flag-u.s.-virgin-islands': VirginIslandsIcon,
  'flag-uruguay': UruguayIcon,
  'flag-uzbekistan': UzbekistanIcon,
  'flag-vanuatu': VanuatuIcon,
  'flag-vatican-city': VaticanCityIcon,
  'flag-venezuela': VenezuelaIcon,
  'flag-vietnam': VietnamIcon,
  'flag-wales': WalesIcon,
  'flag-western-sahara': WesternSaharaIcon,
  'flag-yemen': YemenIcon,
  'flag-zambia': ZambiaIcon,
  'flag-zimbabwe': ZimbabweIcon,
} as const;

export type CountryFlagIconName = keyof typeof COUNTRY_FLAG_ICON_COMPONENTS;

export function getCountryFlagIconComponent(name: CountryFlagIconName) {
  return COUNTRY_FLAG_ICON_COMPONENTS[name] || null;
}
